module.exports = {
  gallery_theme: "compact",
  slider_scale_mode: "down",
  gallery_width: "100%",
  gallery_height: "100%",
  gallery_play_interval: 2500,
  slider_enable_text_panel: true,
  strippanel_enable_handle: false,
  strippanel_padding_top: 7,
  strippanel_padding_bottom: 7,
  strippanel_padding_left: 0,
  strippanel_padding_right: 0,
  strippanel_enable_buttons: true,
  strippanel_enable_mouse_scroll: false,
  strippanel_size_move_factor: 0.8,
  strip_thumbs_align: "center",
  strip_space_between_thumbs: 5,
  slider_enable_zoom_panel: true,
  slider_zoompanel_skin: "",
  slider_zoompanel_align_hor: "left",
  slider_zoompanel_align_vert: "top",
  slider_zoompanel_offset_hor: 0,
  slider_zoompanel_offset_vert: 0,
  slider_play_button_align_hor: "right",
  slider_play_button_align_vert: "top",
  slider_play_button_offset_hor: 60,
  slider_play_button_offset_vert: 12,
  slider_video_enable_closebutton: false,
  slider_enable_fullscreen_button: true,
  slider_fullscreen_native_mode: false,
  slider_fullscreen_button_align_hor: "right",
  slider_fullscreen_button_align_vert: "top",
  slider_fullscreen_button_offset_hor: 11,
  slider_fullscreen_button_offset_vert: 12,
  slider_enable_progress_indicator: false,
  slider_textpanel_text_valign: "middle",
  slider_textpanel_scrollable: true,
  slider_textpanel_padding_top: 10,
  slider_textpanel_padding_bottom: 10,
  slider_textpanel_padding_title_description: 2,
  slider_textpanel_height: null,
  slider_textpanel_bg_opacity: 0.6,
  slider_textpanel_hide_onvideoplay: true,
  gallery_control_thumbs_mousewheel: false,
  gallery_mousewheel_role: "none",
  thumb_border_width: 0,
  thumb_over_border_width: 2,
  thumb_selected_border_width: 5,
  thumb_width: 110,
  thumb_height: 70,
  thumb_overlay_opacity: 0.2
}



// WEBPACK FOOTER //
// ./src/contrib/UniteGalleryDefaults.js